import React from 'react';

export default function AccountsDistribution() {
  return (
    <div>
      <h1>Accounts Distribution</h1>
      <p>This page is under construction.</p>
    </div>
  );
}

